import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=0b2acdfc&scoped=true"
import script from "./stocks.vue?vue&type=script&lang=js"
export * from "./stocks.vue?vue&type=script&lang=js"
import style0 from "./stocks.vue?vue&type=style&index=0&id=0b2acdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2acdfc",
  null
  
)

export default component.exports